import { GroupService } from "../../api/service/group-service";
import { store } from "react-recollect";

export const fetchGroups = async () => {
  store.groups = await GroupService.getGroups();
  return store.groups;
};
